import { Component, OnInit } from '@angular/core';
import { RoutingService, TranslatePipe } from '@spartacus/core';
import { Observable } from 'rxjs';
import { KnBrCommonService } from '../services/kn-br-common.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-login-approver',
    templateUrl: './kn-br-login-approver.component.html',
    styleUrls: ['./kn-br-login-approver.component.scss'],
    imports: [AsyncPipe, TranslatePipe]
})
export class KnBrLoginApproverComponent implements OnInit {
  successMessage$: Observable<string> = this.commonService.approverStatusSuccess$;
  failureMessage$: Observable<string> = this.commonService.approverStatusFailure$;

  constructor(protected routingService: RoutingService, protected commonService: KnBrCommonService) {
    this.routingService.getRouterState().subscribe((state) => {
      if (state?.state?.queryParams) {
        const queryparams = state.state.queryParams;
        if (queryparams.quoteId) {
          this.commonService.updateApproverStatus(state.state.queryParams);
        } else if (queryparams.cartId) {
          this.commonService.updateCartApproverStatus(state.state.queryParams);
        }
      } else {
        this.routingService.go(['/']);
      }
    });
  }

  ngOnInit(): void {}
}
